import { render, staticRenderFns } from "./PendingApprovalTable.vue?vue&type=template&id=2b6b9cef"
import script from "./PendingApprovalTable.vue?vue&type=script&lang=js"
export * from "./PendingApprovalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports